import {queryClient} from "@app/appProvider/queryClient/queryClient";
import {
	QUERY_KEY_POINT_TEMPLATE_BY_ID_SINGLE_VOYAGES,
	QUERY_KEY_POINT_TEMPLATES_BY_IDS_SINGLE_VOYAGES,
	QUERY_KEY_POINT_TEMPLATES_SINGLE_VOYAGES
} from "@containers/singleVoyage/pointTemplates/queryHooks/constants/queryKey";

export const refetchPointTemplatesSingleVoyage = () => {
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_POINT_TEMPLATES_SINGLE_VOYAGES]});
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_POINT_TEMPLATES_BY_IDS_SINGLE_VOYAGES]});
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_POINT_TEMPLATE_BY_ID_SINGLE_VOYAGES]});
}